var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-progress',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.getters['publicProgress/getShowProgress']),expression:"$store.getters['publicProgress/getShowProgress']"}],attrs:{"type":"circle","percentage":_vm.$store.getters['publicProgress/getPublicProgress']}})
}
var staticRenderFns = []

export { render, staticRenderFns }